import { Injectable } from '@angular/core'
import { AbstractTrackEventsService } from './abstract-track-events.service'

@Injectable()
export class TrackEventsServiceStub extends AbstractTrackEventsService {
  trackEvent(event: string, eventCategory: string, eventAction: string, eventLabel: string): void {
    console.log('[TrackEvent]', { event, eventCategory, eventAction, eventLabel })
  }

  trackEventUnitAdded(payload: Record<string, unknown>): void {
    console.log('[TrackEvent] Unit Added', payload)
  }

  trackEventRequestSubmitted(payload: Record<string, unknown>): void {
    console.log('[TrackEvent] Request Submitted', payload)
  }

  override trackPriceRequestEvent(payload: Record<string, unknown>): void {
    console.log('[TrackEvent] Price Request', payload)
  }
}
